import * as React from "react"

import { Button, Row, Col } from "shards-react"

import ielts from "../data/programmes/ielts.json"

// CSEC Logo
import IELTSLogo from "../logos/ielts"

import { routify } from "../js/routify"
import routes from "../data/routes.json"

const IELTSProgrammePreview = props => (
  <div>
    <br />
    <IELTSLogo />

    <br />
    <h5>{ielts.name}</h5>
    <p>{ielts.description}</p>

    <br />
    <Row>
      <Col xs={6}>
        <Button
          disabled
          href={routify(props.countryCode, routes.ielts)}
          style={{ width: "100%" }}
        >
          Learn More
        </Button>
      </Col>
      <Col xs={6}>
        <Button
          outline
          disabled
          href={routify(props.countryCode, routes.ielts)}
          style={{ width: "100%" }}
        >
          Apply Now
        </Button>
      </Col>
    </Row>
  </div>
)

export default IELTSProgrammePreview
